<div class="password-input-container-normal">
  <kh-input [controlType]="currentType()" [controlValue]="password" [placeholder]="placeholder"></kh-input>
  <div class="icon-container cursor" tabindex="-1" (click)="toggleShow()" *ngIf="password.value">
    <fa-icon class="fa cursor fa-lg icon" [icon]="['fas', currentIcon]"></fa-icon>
  </div>
</div>
